import { styled } from '@linaria/react';

function OpacityLabel({ opacity }: { opacity: number | null }) {
  return (
    <Wrapper>
      {typeof opacity === 'number' ? (
        <>opacity: {opacity.toFixed(1)}</>
      ) : (
        'Not Rendered'
      )}
    </Wrapper>
  );
}

const Wrapper = styled.span`
  font-size: 0.625rem;
  font-family: var(--font-family-mono);
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-700);
  white-space: nowrap;
`;

export default OpacityLabel;
